import React, { Component } from 'react'
import {Statistic, Card, Segment, List,  Label, Divider} from 'semantic-ui-react'

/*
    This compoenent calculates displays the basic analytics shown below the graph diplayed on the main dashboard using data passed via the diasboard compoenet. 
    Like the graph, this compoenet also updates in the real-time if real-time listeneser is enabled.
    
*/

export default class Visualisations extends Component{

    renderNodes(){

    }

    render(){
        let currentKey;
        Object.keys(this.props.activeKey).forEach(key =>{
            if(this.props.activeKey[key] === true){
                currentKey = key
            }
        })
        const style ={
            "minWidth":"25%"
        }
        const cardDStyle = {
            "minHeight":"100%",
            "paddingTop":"",
            // "marginLeft":"1px",
            minWidth:"50%"
        }
        const ribbons = {
            float:"left"
        }
        return(
            // <div className='eleven wide column' style ={{margin:'auto'}}>
                <div className='ui stackable grid' style ={{textAlign:'center', minWidth:"100%", margin:"auto"}}>
                     <div className ='sixteen wide column' style={style}>
                        {/* <Segment  style={cardDStyle}> */}
                         <List divided horizontal relaxed>
                             <List.Item>
                                 <List.Content>
                                 <List.Header>Forest Id</List.Header>
                                 {this.props.meta.forest_num} 
                                 </List.Content>
                             </List.Item>
                             <List.Item>
                                 <List.Content>
                                 <List.Header>Node</List.Header>
                                 {this.props.meta.node_num}
                                 </List.Content>
                             </List.Item>
                             <List.Item>
                                 <List.Content>
                                 <List.Header>Coordinates</List.Header>
                                 {this.props.meta.lat_lng  && (this.props.meta.lat_lng[0] + ", " + this.props.meta.lat_lng[1]) }
                                 </List.Content>
                             </List.Item>

                             <List.Item>
                                 <List.Content>
                                 <List.Header>Last Update</List.Header>
                                 {this.props.time}
                                 </List.Content>  
                             </List.Item>
                             <List.Item>
                                 <List.Content>
                                     <List.Header>Battery</List.Header>
                                         {this.props.data[this.props.data.length-1].battery + "%"}
                                     </List.Content>
                             </List.Item>
                         </List>


                        {/* </Segment> */}
                    </div>
                        <div className ='four wide column' style={style}>
                            <Segment  style={cardDStyle}>
                            <Label  color='teal' style={ribbons}ribbon> 
                                        VWC 30
                            </Label>
                                <Card.Content>
                                    {/* <Card.Meta>VWC 30</Card.Meta> */}
                                    <Card.Description>
                                        VWC at <strong>30 cm depth</strong>
                                    </Card.Description>
                                    <Divider/>
                                    <Statistic style={{width:'100%'}} size = "tiny" color ='teal' label='Latest' value={this.props.data[0].vwc30  + ' %'} />                        
                                    <Statistic size = "mini" color ='teal' label='Minimum' value={this.props.getMin("vwc30", currentKey) + ' %'} />    
                                    <Statistic size = "mini" color ='teal' label='Maximum' value={this.props.getMax("vwc30", currentKey) + ' %'} /> 
                                    <Statistic size = "mini" color ='teal' label='Range' value={this.props.range("vwc30", currentKey) + ' %'} /> 
                                    <Statistic size = "mini" color ='teal' label='Mean' value={this.props.average("vwc30", currentKey) + ' %'} />    
                                    
                                </Card.Content>
                            </Segment>
                        </div>
    
                        <div  className = "four wide column" style={style}>
                            <Segment raised style={cardDStyle}>
                            <Label as='a' color='blue' ribbon style={ribbons}>
                                        VWC 60
                            </Label>
                                <Card.Content>
                                    <Card.Description>
                                        VWC at <strong> 60 cm depth</strong>
                                    </Card.Description>
                                    <Divider/>
                                    <Statistic style={{width:'100%'}} size = "tiny" color ='blue' label='Latest' value={this.props.data[0].vwc60  + ' %'} />                               
                                    <Statistic size = "mini" color ='blue' label='Minimum' value={this.props.getMin("vwc60", currentKey) + ' %'} />    
                                    <Statistic size = "mini" color ='blue' label='Maximum' value={this.props.getMax("vwc60", currentKey) + ' %'} />
                                    <Statistic size = "mini" color ='blue' label='Range' value={this.props.range("vwc60", currentKey) + ' %'} />  
                                    <Statistic size = "mini" color ='blue' label='Mean' value={this.props.average("vwc60", currentKey) + ' %'} />     
                                </Card.Content>
                            </Segment>
                        </div>
                        
    
                    <div className = 'four wide column' style={style}>
                        <Segment raised style={cardDStyle}>
                                <Card.Content>
                                <Label as='a' color='yellow' ribbon style={ribbons}>
                                        Temperature
                                </Label>
                                    <Card.Description>
                                        Temp at <strong> 10 cm depth</strong>
                                    </Card.Description>
                                    <Divider/>
                                    <Statistic style={{width:'100%'}} size = "tiny" color ='yellow' label='Latest' value={this.props.data[0].temperature  + ' °C'} />
                                    <Statistic size = "mini" color ='yellow' label='Minimum' value={this.props.getMin("temperature", currentKey) + '°C'} />    
                                    <Statistic size = "mini" color ='yellow' label='Maximum' value={this.props.getMax("temperature", currentKey) + '°C'} /> 
                                    <Statistic size = "mini" color ='yellow' label='Range' value={this.props.range("temperature", currentKey) + ' °C'} /> 
                                    <Statistic size = "mini" color ='yellow' label='Mean' value={this.props.average("temperature", currentKey) + '°C'} />  
                                                    
                                </Card.Content>
                            </Segment>
                        </div>
                        <div className = 'four wide column' style={style}>
                            <Segment raised style={cardDStyle}>
                            <Label as='a' color='black' ribbon style={ribbons}>
                                    Battery
                            </Label>
                                <Card.Content>
                                    <Card.Description>
                                        Battery percentage
                                    </Card.Description>
                                    <Divider/>
                                    <Statistic style={{width:'100%'}} size = "tiny" color ='grey' label='Latest' value={this.props.data[0].battery  + ' %'} />
                                    <Statistic size = "mini" color ='grey' label='Minimum' value={this.props.getMin("battery", currentKey) + ' %'} />    
                                    <Statistic size = "mini" color ='grey' label='Maximum' value={this.props.getMax("battery", currentKey) + ' %'} />
                                    <Statistic size = "mini" color ='grey' label='Range' value={parseInt(this.props.range("battery", currentKey), 10) + ' %'} />
                                    <Statistic size = "mini" color ='grey' label='Mean' value={parseInt(this.props.average("battery", currentKey), 10) + ' %'} />                     
                                </Card.Content>
                            </Segment>
                        </div>
                            


           </div>    
        // </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/visualisations.js